import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "./AuthContext";

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, loading } = useContext(AuthContext);
    const location = useLocation();

    if (loading) {
        return <p>Loading...</p>; // You can replace this with a spinner
    }

    return isAuthenticated ? (
        children
    ) : (
        <Navigate to="/auth" state={{ from: location }} />
    );
};

export default ProtectedRoute;